export const state = () => ({
  filter: {},
  currentPage: 1,
  perPage: 20,
});

export const getters = {
  filter: () => filter,
};

export const mutations = {
  SET_FILTER(state, data) {
    state.filter = data;
  },
  SET_PAGE(state, data) {
    state.currentPage = data;
  },
  SET_PER_PAGE(state, data) {
    state.perPage = data;
  },
};

export const actions = {
  async saveFilter({ commit }, params) {
    try {
      commit('SET_FILTER', params);
    } catch (error) {
      console.log(error);
    }
  },
};
